import { useContext } from 'react';
import { forBrands, Theme, CSSObject, styled } from '@core-ui/react-stitch';
import { BreakpointContext, LARGE } from '@core-ui/breakpoint-provider';

const Card = styled.div(({ theme }) => {
  const { minWidth } = useContext(BreakpointContext);
  const isDesktop = minWidth(LARGE);

  const defaultStyles: CSSObject = {
    minHeight: isDesktop ? '430px' : '340px',
    position: 'relative',
    '.product-card__image': {
      display: 'block',
    },
  };

  const brStyles = (theme: Theme): CSSObject =>
    ({
      ...defaultStyles,
      ...theme.brandFontAlt,
      minHeight: undefined,
      width: '100%',
      height: '100%',
    } as CSSObject);

  return forBrands(theme, {
    br: () => brStyles(theme),
    brfs: () => brStyles(theme),
    default: defaultStyles,
  });
});

export default Card;
